import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import store from "./store/store";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

axios.interceptors.request.use(
  (config) => {
    /* TODO: check if cookie is set or expired here? */
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const isCookieSet = document.cookie
        .split(";")
        .some((cookie) => cookie.trim().startsWith("access_token="));

      if (!isCookieSet) {
        /* TODO: Delete localStorage */
        router.push("/");
      }
    }

    return Promise.reject(error);
  }
);

//Creamos el App
const app = createApp(App);

// Activamos el router
app.use(router, axios, store);

// Aplicacion
app.mount("#app");

